import createWsAction from 'utils/create-ws-action'

// ------------------------------------
// Action Types
// ------------------------------------
export const CLIENT_CREATE = 'unifi.CLIENT_CREATE'
export const CLIENT_GET_FETCH = 'unifi.CLIENT_GET_FETCH'
export const CLIENT_LIST_FETCH = 'unifi.CLIENT_LIST_FETCH'
export const CLIENT_CONFIG_GET_FETCH = 'unifi.CLIENT_CONFIG_GET_FETCH'
export const CLIENT_CONFIG_UPDATE = 'unifi.CLIENT_CONFIG_UPDATE'
export const CLIENT_CONFIG_LIST_FETCH = 'unifi.CLIENT_CONFIG_LIST_FETCH'
export const CLIENT_CONFIG_CREATE = 'unifi.CLIENT_CONFIG_CREATE'

// ------------------------------------
// Action Creators
// ------------------------------------
export const createClient = createWsAction({
  type: CLIENT_CREATE,
  messageType: 'core.client.register-client',
  selectorKey: 'clientDetail',
  fields: ['clientId', 'displayName']
})

export const listClients = createWsAction({
  type: CLIENT_LIST_FETCH,
  messageType: 'core.client.list-clients',
  selectorKey: 'clientList',
  fields: []
})

export const getClient = createWsAction({
  type: CLIENT_GET_FETCH,
  messageType: 'core.client.get-client',
  selectorKey: 'clientDetail',
  fields: ['clientId', 'with'],
  defaultParams: {
    with: ['image']
  }
})

export const getClientConfig = createWsAction({
  type: CLIENT_CONFIG_GET_FETCH,
  messageType: 'core.client.get-client-config',
  selectorKey: 'clientConfigDetail',
  fields: ['targetClientId', 'with']
})

export const updateClientConfig = createWsAction({
  type: CLIENT_CONFIG_UPDATE,
  messageType: 'core.client.edit-client-config',
  selectorKey: 'clientConfigDetail',
  fields: ['clientId', 'targetClientId', 'changes']
})

export const listAllClientConfigs = createWsAction({
  type: CLIENT_CONFIG_LIST_FETCH,
  messageType: 'core.client.list-all-client-configs',
  selectorKey: 'clientConfigList',
  fields: []
})

export const createClientConfig = createWsAction({
  type: CLIENT_CONFIG_CREATE,
  messageType: 'core.client.add-client-config',
  selectorKey: 'clientConfigDetail',
  fields: ['clientId', 'liveViewEnabled', 'visitCalculationEnabled',
    'liveVisitEnabled', 'liveVisitGracePeriod', 'liveVisitMergePeriod']
})

export default null



// WEBPACK FOOTER //
// ./src/redux/modules/model/client.js